

























import { Component, Vue, Prop } from "../vue-ext";
import { HousingCompany, Account, MessageType, AuthResponse, User, Message } from "../models";
import axios from "axios";
import "../components/LoginTopNav";

@Component
export default class InputPinView extends Vue {
    private pin: string = "";
    private user: User | null = null;
    private loading: boolean = false;
    private MessageType = MessageType;

    private created() {
        this.user = this.root.getCurrentUser() as User;
    }

    private mounted() {
        this.sendPin(MessageType.Email);

        setTimeout(() => { 
            (<HTMLInputElement>this.$refs.pin).focus();
        }, 100);
    }

    private sendPin(messageType: MessageType | null = null) {
        if (this.user) { 
            try {
                this.root.service.user.SendPin(this.user.email, messageType);
            } catch (err) {
                
                }
        }
    }

    private async login() {
        if (this.user) {
            this.loading = true;
            const authResponse = await this.service.authentication.requestToken(this.user.email, this.pin);

            if (!authResponse.isError) {
                localStorage.setItem("authToken", authResponse.token);

                if (await this.root.authenticate()) {
                    this.$router.push("/choose-housing-company");
                }
            }
            
            this.loading = false;
        }
    }
}
